/**
 * Hero Carousel — shared between the homepage (`<header id="hero-news-header">`)
 * and the advance-page Marquee variant (`<header id="hero-marquee-header">`).
 *
 * A header opts in by:
 *   - setting `data-hero-carousel="true"` on the `<header>`
 *   - setting `data-carousel-timer="<ms>"` for the slide interval (default 4000)
 *   - setting `data-carousel-type="kenburns"` to add the Ken Burns scale animation
 *   - containing two layer elements: `.hero-carousel-layer-a` and `.hero-carousel-layer-b`
 *   - optionally `.hero-carousel-caption` for the slide caption text
 *   - embedding the slide list as inline JSON inside the header at
 *     `<script type="application/json" class="hero-carousel-data">[...]</script>`
 *     where each slide is `{ image: string, caption?: string }`
 *
 * The homepage continues to emit its slide list inline as a separate <script>
 * (legacy behavior) — for backward compatibility we still pick that path up
 * by looking for a slide-list JSON descendant inside the header element.
 */
document.addEventListener("DOMContentLoaded", function () {
	var headers = document.querySelectorAll("[data-hero-carousel]");
	if (!headers || headers.length === 0) return;

	headers.forEach(function (header) {
		var layerA = header.querySelector(".hero-carousel-layer-a");
		var layerB = header.querySelector(".hero-carousel-layer-b");
		if (!layerA || !layerB) return;

		var dataNode = header.querySelector("script.hero-carousel-data");
		var slides = [];
		if (dataNode && dataNode.textContent) {
			try {
				slides = JSON.parse(dataNode.textContent);
			} catch (err) {
				slides = [];
			}
		}

		// Normalize to homepage's existing { url, caption } shape — supports both
		// { image, caption } (advance-page marquee) and { url, caption } (homepage).
		slides = (slides || [])
			.map(function (s) {
				if (!s) return null;
				var url = s.url || s.image || "";
				if (!url) return null;
				return { url: url, caption: s.caption || "" };
			})
			.filter(Boolean);

		if (slides.length === 0) return;

		var captionEl = header.querySelector(".hero-carousel-caption");
		var timer = parseInt(header.getAttribute("data-carousel-timer"), 10);
		if (!timer || timer < 200) timer = 4000;
		var kenburns =
			(header.getAttribute("data-carousel-type") || "").toLowerCase() ===
				"kenburns" || header.classList.contains("is-kenburns");

		// Preload all images.
		slides.forEach(function (s) {
			var img = new Image();
			img.src = s.url;
		});

		if (kenburns) {
			header.style.setProperty("--hero-kenburns-duration", timer + "ms");
		}

		function restartKenburns(el) {
			el.classList.remove("kenburns");
			// Force reflow so the animation restarts when re-added.
			void el.offsetWidth;
			el.classList.add("kenburns");
		}

		function setBg(el, url) {
			el.style.backgroundImage = "url('" + url + "')";
			if (kenburns) restartKenburns(el);
		}

		function setCaption(text) {
			if (!captionEl) return;
			var hasText = text && String(text).trim().length > 0;
			if (hasText) {
				captionEl.textContent = text;
				captionEl.classList.add("is-visible");
			} else {
				captionEl.textContent = "";
				captionEl.classList.remove("is-visible");
			}
		}

		// First slide.
		var i = 0;
		var active = "A";
		setBg(layerA, slides[0].url);
		setCaption(slides[0].caption || "");
		layerA.classList.add("is-active");

		if (slides.length > 1) {
			setInterval(function () {
				var nextIndex = (i + 1) % slides.length;
				if (active === "A") {
					setBg(layerB, slides[nextIndex].url);
					layerB.classList.add("is-active");
					layerA.classList.remove("is-active");
					active = "B";
				} else {
					setBg(layerA, slides[nextIndex].url);
					layerA.classList.add("is-active");
					layerB.classList.remove("is-active");
					active = "A";
				}
				setCaption(slides[nextIndex].caption || "");
				i = nextIndex;
			}, timer);
		}
	});
});
